/**
 * @generated SignedSource<<5547fa192d15a880666acd03da46e35d>>
 * @relayHash e38398f7b927425d1f54e0f04a11e390
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e38398f7b927425d1f54e0f04a11e390

import { ConcreteRequest } from 'relay-runtime';
export type SetAdditionalCapacityInput = {
  additionalPoolCapacity: number;
  additionalReservedCapacity: number;
  date: any;
  slotId: number;
};
export type useUpdateCapacityMutation$variables = {
  input: SetAdditionalCapacityInput;
};
export type useUpdateCapacityMutation$data = {
  readonly setAdditionalCapacity: {
    readonly poolCapacityValuesOutput: {
      readonly additionalPoolCapacity: number;
      readonly additionalReservedCapacity: number;
      readonly availableEmergencyCapacity: number;
      readonly availablePoolCapacity: number;
      readonly bookedEmergencyCapacity: number;
      readonly bookedPoolCapacity: number;
      readonly date: any;
      readonly explanation: string;
      readonly forecastedCapacity: number;
      readonly id: string;
      readonly initialReservedCapacity: number;
      readonly isCurrentSlot: boolean;
      readonly overbookedEmergencyCapacity: number;
      readonly plannedEmergencyCapacity: number;
      readonly plannedPoolCapacity: number;
      readonly poolCapacity: number;
      readonly reservedCapacity: number;
      readonly slotId: number;
    } | null;
  };
};
export type useUpdateCapacityMutation = {
  response: useUpdateCapacityMutation$data;
  variables: useUpdateCapacityMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetAdditionalCapacityPayload",
    "kind": "LinkedField",
    "name": "setAdditionalCapacity",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PoolCapacityValuesOutput",
        "kind": "LinkedField",
        "name": "poolCapacityValuesOutput",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slotId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "forecastedCapacity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "additionalPoolCapacity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "additionalReservedCapacity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "initialReservedCapacity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reservedCapacity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "plannedPoolCapacity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "poolCapacity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "explanation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isCurrentSlot",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bookedEmergencyCapacity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bookedPoolCapacity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "availableEmergencyCapacity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "availablePoolCapacity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "overbookedEmergencyCapacity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "plannedEmergencyCapacity",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateCapacityMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUpdateCapacityMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "e38398f7b927425d1f54e0f04a11e390",
    "metadata": {},
    "name": "useUpdateCapacityMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4f35c3e41ff7c50a4482a64fdd34e5ba";

export default node;
